import { render } from "./ReferralInformation.vue?vue&type=template&id=5c216690&scoped=true"
import script from "./ReferralInformation.vue?vue&type=script&lang=js"
export * from "./ReferralInformation.vue?vue&type=script&lang=js"

import "./ReferralInformation.vue?vue&type=style&index=0&id=5c216690&scoped=true&lang=css"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c216690"]])

export default __exports__